// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mockup: false,

  AUTH_SERVICE_ENDPOINT: '/cpha-auth',
  API_SERVICE_ENDPOINT: '/cps-api',
  COMMONS_SERVICE_ENDPOINT: 'https://preprod.commonwebservices.ca/cpha-commons-rest-ws',
  PROXY_SERVICE_ENDPOINT: '/cps-proxy',
  HUB_ENDPOINT: 'https://hub-preprod.pharmacists.ca',
  CPS2_DOMAIN: 'https://cps-preprod.pharmacists.ca'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
